import { Component } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { FaIconComponent } from '@fortawesome/angular-fontawesome'
import { WjInputModule } from '@grapecity/wijmo.angular2.input'

import { MonthlyPlan, RepositoryModal } from '../../../shared'

@Component({
    templateUrl: './monthly-plan.component.html',
    standalone: true,
    imports: [FormsModule, WjInputModule, FaIconComponent],
})
export class MonthlyProjectionPlanComponent extends RepositoryModal<MonthlyPlan> {
    onBeforeSave() {
        // Basic Validation
        if (!this.target.date || !this.target.revenue || !this.target.profit) {
            this.services.notification.warning('Please enter values for all fields.')
            return false
        }

        // the date should just be the first of the month, so adjust if needed.
        this.target.date = new Date(this.target.date.getFullYear(), this.target.date.getMonth(), 1)

        // If the user is trying to add, and the repo already has that date, don't allow add, and tell them to edit existing.
        if (this.isAdding) {
            const year = this.target.date.getFullYear()
            const month = this.target.date.getMonth()
            const match = this.services.data.monthlyPlans.items.find(x => x.date.getFullYear() === year && x.date.getMonth() === month)
            if (match) {
                this.services.notification.warning(
                    'A record already exists for that year and month. Please choose another date or edit the existing record.',
                )
                return false
            }
        }
        return true
    }
}
